import { render } from 'react-dom';
import React from 'react';
import { Provider } from 'react-redux';
import { createStore } from 'redux';
import { Router, Route, hashHistory, IndexRoute } from 'react-router';

import App from './pages/App.js';
import Home from './components/Home.js';
import Arbeiten from './components/Arbeiten.js';
import Veroffentlichungen from './components/Veroffentlichungen.js';
import KontaktAktuell from './components/KontaktAktuell.js';
import reducers from './reducers';
import Schalen from './components/Schalen.js';
import Objekte from './components/Objekte.js';
import Neriage from './components/Neriage.js';
import Rauchverband from './components/Rauchverband';
import ArbeitenHome from './components/ArbeitenHome';

const store = createStore(
  reducers,
  window.__REDUX_DEVTOOLS_EXTENSION__ &&
  window.__REDUX_DEVTOOLS_EXTENSION__()
  );

const root = document.createElement('div');
document.body.appendChild(root);

render(
  <Provider store={store}>
    <Router history={hashHistory}>
      <Route path="/" component={App}>
        <IndexRoute component={Home} />
        <Route path="/home" component={Home} />
        <Route path="/arbeiten" component={Arbeiten}>
          <IndexRoute component={ArbeitenHome} />
          <Route path="/arbeiten/schalen" component={Schalen} />
          <Route path="/arbeiten/objekte" component={Objekte} />
          <Route path="/arbeiten/neriage" component={Neriage} />
          <Route path="/arbeiten/rauchverband" component={Rauchverband} />
        </Route>
        <Route path="/veröffentlichungen" component={Veroffentlichungen} />
        <Route path="/kontaktAktuell" component={KontaktAktuell} />
      </Route>
    </Router>
  </Provider>,
  root
);



// WEBPACK FOOTER //
// ./src/index.js